<!--<section class="bg-gray-50 min-h-screen"> -->
<!--<div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6"> -->
<div class="pl-[130px] 3xl:pl-[140px] 4xl:pl-[150px] pr-[42px] 3xl:pr-[52px] 4xl:pr-[60px]">
  <!-- Title + Tabs -->
    <h2 class="mb-4 mt-0 2xl:mb-6 3xl:mt-2 text-[1.5rem] xl:text-[1.8rem] 2xl:text-[1.9rem] 3xl:text-[2.1rem] 4xl:text-[2.3em] text-dimot-1">
      Lista dei Prodotti
    </h2>
    <div class="flex flex-row justify-between">

   <ul class="flex flex-nowrap -mb-px w-[300px] text-[0.7em] xl:text-[0.8em] 2xl:text-[0.9em] 3xl:text-[1.08em] 4xl:text-[1.15em]">
  <li class="cursor-pointer" (click)="filterByLaunchStatus(false); selectTab('inLancio')">
    <a
      class="inline-block p-4 rounded-t-lg border-b-2"
      [ngClass]="{
        'text-dimot-3 border-dimot-3': selectedTab === 'inLancio',
        'text-gray-500 border-gray-300 hover:text-gray-700 hover:border-gray-300': selectedTab !== 'inLancio'
      }"
    >
      <h1 *ngIf="selectedTab === 'inLancio'">In lancio</h1>
      <span *ngIf="selectedTab !== 'inLancio'">In lancio</span>
    </a>
  </li>

  <li class="cursor-pointer" (click)="filterByLaunchStatus(true); selectTab('sulMercato')">
    <a
      class="inline-block p-4 rounded-t-lg border-b-2"
      [ngClass]="{
        'text-dimot-3 border-dimot-3': selectedTab === 'sulMercato',
        'text-gray-500 border-gray-300 hover:text-gray-700 hover:border-gray-300': selectedTab !== 'sulMercato'
      }"
    >
      <h1 *ngIf="selectedTab === 'sulMercato'">Sul mercato</h1>
      <span *ngIf="selectedTab !== 'sulMercato'">Sul mercato</span>
    </a>
  </li>
</ul>



  

  <!-- Search Form -->
  <form class="w-[200px] xl:w-[250px] 2xl:w-[300px] 3xl:w-[350px] 4xl:w-[400px]">
    <label
      for="default-search"
      class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
      >Search</label
    >
    <div class="relative">
      <!-- Search Icon -->
      <div
        class="absolute inset-y-0 start-0 flex items-center ps-4 pointer-events-none"
      >
       <svg width="14" height="14"
       class="w-[14px] h-[14px] xl:w-[16px] xl:h-[16px] 2xl:w-[18px] 2xl:h-[18px] 3xl:w-[20px] 3xl:h-[20px] 4xl:w-[22px] 4xl:h-[22px]"
       viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.2652 12.7352L10.0539 9.52392C10.9696 8.47082 11.4407 7.1033 11.3679 5.70965C11.295 4.31599 10.6838 3.00507 9.66326 2.05322C8.64269 1.10137 7.29241 0.582961 5.89706 0.607263C4.50171 0.631565 3.1703 1.19668 2.18349 2.18349C1.19668 3.1703 0.631565 4.50171 0.607263 5.89706C0.582961 7.29241 1.10137 8.64269 2.05322 9.66326C3.00507 10.6838 4.31599 11.295 5.70965 11.3679C7.1033 11.4407 8.47082 10.9696 9.52392 10.0539L12.7352 13.2652C12.8063 13.3314 12.9003 13.3675 12.9974 13.3658C13.0946 13.364 13.1873 13.3247 13.256 13.256C13.3247 13.1873 13.364 13.0946 13.3658 12.9974C13.3675 12.9003 13.3314 12.8063 13.2652 12.7352ZM1.37517 6.00017C1.37517 5.08543 1.64642 4.19123 2.15462 3.43065C2.66282 2.67008 3.38515 2.07728 4.23026 1.72722C5.07536 1.37717 6.0053 1.28558 6.90246 1.46403C7.79962 1.64249 8.62372 2.08298 9.27054 2.7298C9.91735 3.37662 10.3578 4.20071 10.5363 5.09787C10.7148 5.99504 10.6232 6.92497 10.2731 7.77008C9.92305 8.61519 9.33026 9.33751 8.56968 9.84571C7.8091 10.3539 6.91491 10.6252 6.00017 10.6252C4.774 10.6237 3.59847 10.1359 2.73144 9.26889C1.86441 8.40186 1.37665 7.22634 1.37517 6.00017Z" fill="#6A7282"/>
</svg>

      </div>
      <!-- Search Input Field -->
      <input
        type="search"
        id="default-search"
        class="block w-full h-[40px] xl:h-[45px] 2xl:h-[50px] 3xl:h-[60px] 4xl:h-[70px]
         ps-10 2xl:ps-12 3xl:ps-14 4xl:ps-16 text-[0.7em] xl:text-[0.75em] 2xl:text-[0.88em] 3xl:text-[1.04em] 4xl:text-[1.16em]
         border-1 border-gray-200 text-gray-900 rounded-2xl bg-white focus:outline-none focus:ring-0 placeholder-[#6A7282]"
        placeholder="Cerca farmaco"
        [(ngModel)]="farmacoFiltered"
        (ngModelChange)="filterMedicines()"
        [ngModelOptions]="{ standalone: true }"
      />
    </div>
  </form>
  </div>


<!-- Cards Section -->
<div class="w-full mt-10 3xl:mt-12 4xl:mt-14">
  <div class="flex flex-wrap gap-x-5 3xl:gap-x-8 4xl:gap-x-12 gap-y-10 3xl:gap-y-12 4xl:gap-y-14">
    <div class="w-full flex flex-row gap-x-4" *ngIf="medicines.length === 0">
      <ng-container *ngIf="showSkeleton">
        <app-skeleton-medicine-card
          *ngFor="let _ of [1, 2]"
        ></app-skeleton-medicine-card>
      </ng-container>
    </div>
    <app-card
      *ngFor="let medicine of medicines"
      [id]="medicine.id"
      [businessName]="medicine.businessName"
      [creationDate]="medicine.creationDate"
      [activeSubstance]="medicine.activeSubstance"
      [therapeuticArea]="medicine.therapeuticArea"
      [therapeuticIndication]="medicine.therapeuticIndication"
      [reimbursementClass]="medicine.reimbursementClass"
      [supplyClass]="medicine.supplyClass"
      [openToAccessType]="medicine.openToAccessType"
      (infoClicked)="openModalByIndex(medicine.id)"
      (farmacoToDashboard)="goToDashboard($event)"
    >
    </app-card>
  </div>
</div>

<!-- NO Medicines Note-->
<div class="mr-6" *ngIf="noMedicinesFound">
  <app-no-medicines-note> </app-no-medicines-note>
</div>

<!-- Modal -->
<app-info-product-modal
  *ngIf="modalFarmacoOpen == true"
  [farmacoToShowData]="farmacoToModal"
  (close)="closeModal()"
></app-info-product-modal>

</div>

<!-- </div> -->
<!-- </section> -->
